import React from 'react';

import AuthFooter from '@/components/molecules/AuthFooter/AuthFooter';
import AuthHeader from '@/components/molecules/AuthHeader/AuthHeader';

const PrivacyPolicyPage: React.FC = () => (
  <div className="min-h-screen bg-background text-foreground">
    <AuthHeader />

    <main className="px-6 py-12 lg:px-12">
      <div className="privacy-policy-page mx-auto w-full max-w-4xl rounded-3xl border border-border bg-card px-6 py-8 shadow-elegant sm:px-8 lg:px-10">
        <h1 className="privacy-policy-h1">
          Privacy Policy
          <br />
          <span>Last Updated On 08-Apr-2026</span>
          <br />
          <span>Effective Date 08-Apr-2026</span>
        </h1>

        <p className="privacy-policy-p">
          This Privacy Policy describes the policies of SIX3RO, 11350 Random Hills Road, Suite 841, VA 22030,
          United States of America (the), email: privacy@six3ro.com, phone: 1703721-8202 on the collection,
          use and disclosure of your information that we collect when you use our website ( https://six3ro.com ).
          (the "Service"). By accessing or using the Service, you are consenting to the collection, use and
          disclosure of your information in accordance with this Privacy Policy. If you do not consent to the
          same, please do not access or use the Service.
        </p>

        <p className="privacy-policy-p">
          We may modify this Privacy Policy at any time without any prior notice to you and will post the revised
          Privacy Policy on the Service. The revised Policy will be effective 180 days from when the revised
          Policy is posted in the Service and your continued access or use of the Service after such time will
          constitute your acceptance of the revised Privacy Policy. We therefore recommend that you periodically
          review this page.
        </p>

        <ol className="privacy-policy-ol">
          <li>
            <h2 className="privacy-policy-h2">Information We Collect:</h2>

            <p className="privacy-policy-p">
              We will collect and process the following personal information about you:
            </p>

            <ol className="privacy-policy-ol">
              <li>Name</li>
              <li>Email</li>
              <li>Mobile</li>
            </ol>
          </li>

          <li>
            <h2 className="privacy-policy-h2">How We Use Your Information:</h2>

            <p className="privacy-policy-p">
              We will use the information that we collect about you for the following purposes:
            </p>

            <ol className="privacy-policy-ol">
              <li>Creating user account</li>
            </ol>

            <p className="privacy-policy-p">
              If we want to use your information for any other purpose, we will ask you for consent and will use
              your information only on receiving your consent and then, only for the purpose(s) for which grant
              consent unless we are required to do otherwise by law.
            </p>
          </li>

          <li>
            <h2 className="privacy-policy-h2">Retention Of Your Information:</h2>

            <p className="privacy-policy-p">
              We will retain your personal information with us for 90 days to 2 years after users terminate
              their accounts or for as long as we need it to fulfill the purposes for which it was collected as
              detailed in this Privacy Policy. We may need to retain certain information for longer periods such
              as record-keeping / reporting in accordance with applicable law or for other legitimate reasons like
              enforcement of legal rights, fraud prevention, etc. Residual anonymous information and aggregate
              information, neither of which identifies you (directly or indirectly), may be stored indefinitely.
            </p>
          </li>

          <li>
            <h2 className="privacy-policy-h2">Your Rights:</h2>

            <p className="privacy-policy-p">
              Depending on the law that applies, you may have a right to access and rectify or erase your
              personal data or receive a copy of your personal data, restrict or object to the active processing
              of your data, ask us to share (port) your personal information to another entity, withdraw any
              consent you provided to us to process your data, a right to lodge a complaint with a statutory
              authority and such other rights as may be relevant under applicable laws. To exercise these rights,
              you can write to us at privacy@six3ro.com. We will respond to your request in accordance with
              applicable law.
            </p>

            <p className="privacy-policy-p">
              Do note that if you do not allow us to collect or process the required personal information or
              withdraw the consent to process the same for the required purposes, you may not be able to access
              or use the services for which your information was sought.
            </p>
          </li>

          <li>
            <h2 className="privacy-policy-h2">Cookies Etc.</h2>

            <p className="privacy-policy-p">
              To learn more about how we use these and your choices in relation to these tracking technologies,
              please refer to our <a href="https://six3ro.com">Cookie Policy.</a>
            </p>
          </li>

          <li>
            <h2 className="privacy-policy-h2">Security:</h2>

            <p className="privacy-policy-p">
              The security of your information is important to us and we will use reasonable security measures to
              prevent the loss, misuse or unauthorized alteration of your information under our control. However,
              given the inherent risks, we cannot guarantee absolute security and consequently, we cannot ensure
              or warrant the security of any information you transmit to us and you do so at your own risk.
            </p>
          </li>

          <li>
            <h2 className="privacy-policy-h2">Grievance / Data Protection Officer:</h2>

            <p className="privacy-policy-p">
              If you have any queries or concerns about the processing of your information that is available with
              us, you may email our Grievance Officer at SIX3RO, 11350 Random Hills Road, Suite 841, email:
              privacy@six3ro.com. We will address your concerns in accordance with applicable law.
            </p>
          </li>
        </ol>

        <p className="privacy-policy-p">
          Privacy Policy generated with{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.cookieyes.com/?utm_source=PP&utm_medium=footer&utm_campaign=UW"
          >
            CookieYes
          </a>
          .
        </p>
      </div>

      <div className="mx-auto w-full max-w-4xl pt-8">
        <AuthFooter />
      </div>
    </main>
  </div>
);

export default PrivacyPolicyPage;
